export const CUSTOM_REPORT_PACKAGE = 'custom-reports'

export const CUSTOM_REPORT_PACKAGE_META = {
  name: CUSTOM_REPORT_PACKAGE,
  meta: {
    displayName: 'Custom Reports',
    description: 'Tailored insights shared with you by Deloitte practitioners.',
  },
}
